import React from "react";
import { useNavigate } from "react-router-dom";
import * as styles from "./sideMenu.css";

type SideMenuProps = {
  isOpen: boolean;
  onClose: () => void;
};

const menuItems = [
  { label: "HOME", link: "/" },
  { label: "CONCEPT", link: "/ourthoughts" },
  { label: "MENU", link: "/lunchmenu" },
  { label: "EVENT", link: "#event" },
  { label: "ACCESS", link: "#access" },
  { label: "RESERVATION", link: "#reservation" },
  { label: "ONLINE STORE", link: "https://kitchen-muku.stores.jp" },
  { label: "ABOUT US", link: "#aboutus" },
];

export const SideMenu: React.FC<SideMenuProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleClick = (link: string) => {
    if (link.startsWith('/')) {
      if (link === '/ourthoughts') {
        window.scrollTo(0, 0);
      }
      navigate(link);
    } else if (link.startsWith('#')) {
      const element = document.querySelector(link);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = link;
    }
    onClose();
  };

  return (
    <nav className={`${styles.menuContainer} ${isOpen ? styles.menuOpen : ""}`}>
      <button 
        className={styles.closeButton}
        onClick={onClose}
        aria-label="メニューを閉じる"
      />
      <ul className={styles.menuList}>
        {menuItems.map((item) => (
          <li key={item.label} className={styles.menuItem}>
            <a 
              href={item.link} 
              className={styles.menuLink} 
              onClick={(e) => {
                e.preventDefault();
                handleClick(item.link);
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}; 